<template>
  <div class="main-footer" v-once>
    <div class="container">
      <el-row>
        <el-col :md="10">
          <ul class="list-unstyled list-spaced">
            <li class="mb-2">
              <h6 class="text-uppercase">About</h6>
            </li>
            <li class="text-muted">
              PTDefender was built from the ground up to provide the most secure and reliable means of recovering losses in ProfitTrailer. It's a fully automated system that works on macOS, Windows and Linux.
            </li>
          </ul>
        </el-col>
        <el-col :md="4" :offset="2">
          <ul class="list-unstyled list-spaced">
            <li class="mb-2">
              <h6 class="text-uppercase">Product</h6>
            </li>
            <li class="text-muted">
              <router-link to="/features">Features</router-link>
            </li>
            <li class="text-muted">
              <router-link to="/pricing">Pricing</router-link>
            </li>
            <li class="text-muted">
              <router-link to="/download">Download</router-link>
            </li>
          </ul>
        </el-col>
        <el-col :md="4">
          <ul class="list-unstyled list-spaced">
            <li class="mb-2">
              <h6 class="text-uppercase">Support</h6>
            </li>
            <li class="text-muted">
              <a href="https://github.com/PTDefender/Welcome/wiki/Quick-Setup-Instructions">Setup</a>
            </li>
            <li class="text-muted">
              <a href="https://github.com/PTDefender/Welcome/wiki/FAQ">FAQ</a>
            </li>
            <li class="text-muted">
              <a href="https://github.com/PTDefender/Welcome/wiki/Settings-Explained">Settings</a>
            </li>
          </ul>
        </el-col>
        <el-col :md="4">
          <ul class="list-unstyled list-spaced">
            <li class="mb-2">
              <h6 class="text-uppercase">Legal</h6>
            </li>
            <li class="text-muted">
              <router-link to="/terms">Terms</router-link>
            </li>
            <li class="text-muted">
              <router-link to="/privacy">Privacy</router-link>
            </li>
            <li class="text-muted">
              <router-link to="/disclaimer">Disclaimer</router-link>
            </li>
          </ul>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainFooter'
}
</script>

<style lang="scss">
.main-footer {
  color: #fff;
  padding: 40px 8px;
  background-color: #272c35;
  ul {
    list-style-type: none;
    padding: 0;
  }
  ul li {
    line-height: 24px;
  }
  ul li a {
    color: inherit;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
  .text-uppercase {
    text-transform: uppercase;
    margin-bottom: 8px;
    font-size: 16px;
    opacity: 0.8;
  }
  .text-muted {
    opacity: 0.4;
  }
}
</style>
